import { AnalysisArtifacts } from '../types/conversation';

export type DownloadKind = 'xlsx' | 'csv' | 'pdf' | 'docx' | 'pptx' | null;

export const detectDownloadKind = (
  mimeType?: string,
  filename?: string,
  href?: string
): DownloadKind => {
  const mime = String(mimeType || '').toLowerCase();
  const name = String(filename || '').toLowerCase();
  const link = String(href || '').toLowerCase();

  if (
    mime.includes('spreadsheet') ||
    mime.includes('excel') ||
    /\.xlsx?($|\?)/i.test(name) ||
    /\.xlsx?($|\?)/i.test(link) ||
    /xlsx/.test(link)
  ) {
    return 'xlsx';
  }
  if (
    mime.includes('wordprocessingml') ||
    mime.includes('msword') ||
    /\.docx?($|\?)/i.test(name) ||
    /\.docx?($|\?)/i.test(link) ||
    /docx?/.test(link) ||
    /word/.test(link)
  ) {
    return 'docx';
  }
  if (
    mime.includes('presentationml') ||
    mime.includes('powerpoint') ||
    /\.pptx?($|\?)/i.test(name) ||
    /\.pptx?($|\?)/i.test(link) ||
    /pptx?/.test(link)
  ) {
    return 'pptx';
  }
  if (
    mime.includes('pdf') ||
    /\.pdf($|\?)/i.test(name) ||
    /\.pdf($|\?)/i.test(link)
  ) {
    return 'pdf';
  }
  if (
    mime.includes('csv') ||
    /\.csv($|\?)/i.test(name) ||
    /\.csv($|\?)/i.test(link) ||
    /csv/.test(link)
  ) {
    return 'csv';
  }
  return null;
};

export const resolveArtifactBase64 = (
  kind: DownloadKind,
  preferredBase64: string,
  artifacts?: AnalysisArtifacts | null
): string => {
  const rawPreferred = String(preferredBase64 || '').trim();
  if (rawPreferred) {
    return rawPreferred;
  }
  if (!artifacts) {
    return '';
  }
  if (kind === 'csv') {
    return String(artifacts.csv_base64 || '').trim();
  }
  if (kind === 'xlsx') {
    return String(artifacts.xlsx_base64 || '').trim();
  }
  if (kind === 'pdf') {
    return String(artifacts.pdf_base64 || '').trim();
  }
  if (kind === 'docx') {
    return String(artifacts.docx_base64 || '').trim();
  }
  if (kind === 'pptx') {
    return String(artifacts.pptx_base64 || '').trim();
  }
  return '';
};

export const resolveArtifactDownloadUrl = (
  kind: DownloadKind,
  artifacts?: AnalysisArtifacts | null
): string => {
  if (!artifacts) {
    return '';
  }
  if (kind === 'csv') {
    return String(artifacts.csv_download_url || '').trim();
  }
  if (kind === 'xlsx') {
    return String(artifacts.xlsx_download_url || '').trim();
  }
  if (kind === 'pdf') {
    return String(artifacts.pdf_download_url || '').trim();
  }
  if (kind === 'docx') {
    return String(artifacts.docx_download_url || '').trim();
  }
  if (kind === 'pptx') {
    return String(artifacts.pptx_download_url || '').trim();
  }
  return '';
};

export const shouldBlockTruncatedCompleteDownload = (
  kind: DownloadKind,
  truncated: boolean,
  hasCompleteArtifact: boolean
): boolean => Boolean(kind && truncated && !hasCompleteArtifact);
